/**
 * formatCostBeforeSandToBack - беку нужны рубли в копейках
 * @param cost {string | number}
 */
export const doFormatCostBeforeSandToBack = (cost: string | number) => Number(cost) * 100;
export const doFormatCostFromBack = (cost: string | number | undefined) => Number(cost) / 100;
